import React from "react";

import SBCLinkCell from "ComparePlans/Components/SBCLinkCell";
import { map } from "lodash";
import formatCurrency from "Utils/formatCurrency";

import { Table, TR, TD, TH } from "Cobalt/TableV2";
import { Card, CardHeader, CardSection } from "Common/Card";

// Constants lifted from dental_plan.rb
export const DISPLAY_CATEGORIES = {
  Preventive: ["Tooth Cleaning (every 6 months)"],
  Cavities: ["Filling (1 surface)"],
  Crowns: ["Porcelain and Steel"],
  Periodontics: ["Deep Cleaning (Scaling & Planing, per quadrant)"],
  Endodontics: ["Root Canal (single)"],
  "Tooth Extraction": ["Normal"],
  Orthodontics: ["Adult"],
};
export const DISPLAY_TERM_NAMES = {
  "Tooth Cleaning (every 6 months)": "Semi-Annual Cleaning",
  "Dental Exam & X-rays (preventive)": "Check-up and X-rays (preventive)",
  "Deep Cleaning (Scaling & Planing, per quadrant)": "Deep Cleaning of the Gums (Scaling & Planing, per quadrant)",
  "Gum Surgery (Gingivectomy) per tooth": "Gum Surgery (Gingivectomy, per tooth)",
  "Root Canal (single)": "Root Canal",
  Adult: "Braces - Adult",
};

const TermRow = ({ term, plan, category }) => (
  <TR highlightFirstCell={false}>
    <TD>{[category, DISPLAY_TERM_NAMES[term] || term].join(" - ")}</TD>
    <TD>{plan.fine_print[category][term]}</TD>
  </TR>
);

const DentalPlanDetails = ({ plan, className }) => (
  <div className="common-plan">
    <Card theme="flat" className="common-plan-section section-holder" p={0}>
      <CardHeader>Plan Overview</CardHeader>
      <CardSection>
        <Table data-testid="DentalPlanDetails--Overview" className={className}>
          <tbody>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Maximum Benefit</TD>
              <TD>{formatCurrency(plan.annual_maximum)}</TD>
            </TR>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Deductible</TD>
              <TD>{formatCurrency(plan.deductible)}</TD>
            </TR>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Preventative Care</TD>
              <TD>{plan.preventive_care}</TD>
            </TR>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Cavities</TD>
              <TD>{plan.cavities}</TD>
            </TR>
            <TR highlightFirstCell={false}>
              <TD className="w-2/5">Plan Document</TD>
              <TD>
                <SBCLinkCell plan={plan} />
              </TD>
            </TR>
          </tbody>
        </Table>
      </CardSection>
    </Card>

    <Card theme="flat" p={0}>
      <CardHeader>Plan Details</CardHeader>
      <CardSection>
        <Table data-testid="DentalPlanDetails--Details">
          <thead>
            <TR>
              <TH className="w-2/5">Plan Term</TH>
              <TH>Plan Value</TH>
            </TR>
          </thead>
          {map(DISPLAY_CATEGORIES, (terms, category) => (
            <tbody key={category}>
              {map(terms, (term) => (
                <TermRow term={term} plan={plan} category={category} key={`${category}-${term}`} />
              ))}
            </tbody>
          ))}
        </Table>
      </CardSection>
    </Card>
  </div>
);

export default DentalPlanDetails;
